var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2LaunchApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 14v17.29l-7.39-7.07L28.23 49.6l-2.83-2.83 25.38-25.38L43.71 14H61zM51 59H17V25h19.92L41 21H13v42h42V34l-4 4.25V59z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Launch_app.ef99ebd1.svg";
export { SvgJ2LaunchApp as ReactComponent };